export const term = {
    "3yearsShort": "In-3-Years",
    "1yearShort": "In-1-Year",
    thisSemesterShort: "This-Semester",
}
